import React from 'react';

interface IPageNotAccess {
  pageCode: string;
  title: string;
  desc?: string;
}
const PageNotAccess = ({ pageCode, title, desc }: IPageNotAccess) => {
  return (
    <div className='p-page-error'>
      <div className='page-wrapper'>
        <div className='page-container'>
          <div className='page-code'>{pageCode}</div>
          <div className='page-title'>{title}</div>
          <div className='page-desc'>{desc}</div>
          <div className='page-shadow'></div>
        </div>
      </div>
    </div>
  );
};

export default PageNotAccess;
